import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { css, StyleSheet } from 'aphrodite/no-important';
import {
  FONTS,
  MEDIA_QUERIES,
  DOVE_GRAY,
  WILD_SAND,
  CENTER,
  LOCHMARA,
} from '../styles';
import Button, { TYPES } from './Button';
import Link from './Link';
import Panel from './Panel';
import { BASENAME } from '../config';

const s = StyleSheet.create({
  root: {
    flexDirection: 'column',
  },
  bracketDetails: {
    display: 'flex',
    width: '100%',
    alignItems: CENTER,
    flexWrap: 'wrap',
  },
  title: {
    fontSize: 20,
    ...FONTS.BOLD,
    marginRight: 'auto',
  },
  edit: {
    marginRight: 10,
  },
  copyCodeContainer: {
    width: '100%',
    borderTop: `1px solid ${WILD_SAND}`,
    paddingTop: 5,
    marginTop: 10,
    display: 'none',
    [MEDIA_QUERIES.ON_DESKTOP]: {
      display: 'block',
    },
  },
  cloneCodeButton: {
    color: DOVE_GRAY,
    padding: 0,
    fontSize: 12,
    textDecoration: 'underline',
    ':hover': {
      filter: 'brightness(70%)',
    },
  },
  buttonContainer: {
    display: 'none',
    [MEDIA_QUERIES.ON_DESKTOP]: {
      display: 'block',
    },
  },
  expand: {
    display: 'block',
    [MEDIA_QUERIES.ON_DESKTOP]: {
      display: 'none',
    },
  },
  active: {
    color: LOCHMARA,
  },
  visible: {
    display: 'block',
  },
  buttonContainerMobile: {
    paddingTop: 10,
    flexBasis: '100%',
  },
  toggleMobile: {
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    display: 'block',
    zIndex: 1,
    [MEDIA_QUERIES.ON_DESKTOP]: {
      display: 'none',
    },
  },
});

const Bracket = ({ title, id, onDelete, onCopy }) => {
  const [isVisible, setVisible] = useState(false);
  return (
    <Panel __className={s.root}>
      <div className={css(s.bracketDetails)}>
        <p children={title} className={css(s.title)} />
        {!isVisible && (
          <div
            onClick={() => setVisible(!isVisible)}
            className={css(s.toggleMobile)}
          />
        )}
        <Button
          iconName="pagination-filled"
          __type={TYPES.TRANSPARENT}
          __className={[s.expand, isVisible && s.active]}
          onClick={() => setVisible(!isVisible)}
        />
        <div
          className={css(
            s.buttonContainer,
            isVisible && s.visible,
            isVisible && s.buttonContainerMobile
          )}
        >
          <Button
            messageId="app.edit"
            __className={s.edit}
            component={Link}
            to={`${BASENAME}/tree/edit/${id}`}
          />
          <Button
            messageId="app.delete"
            __type={TYPES.SECONDARY}
            onClick={onDelete}
          />
        </div>
      </div>
      <div className={css(s.copyCodeContainer, isVisible && s.visible)}>
        <Button
          messageId="app.bracket.copy.code"
          __type={TYPES.DEFAULT}
          onClick={onCopy}
          __className={s.cloneCodeButton}
        />
      </div>
    </Panel>
  );
};

Bracket.propTypes = {
  title: PropTypes.string,
  id: PropTypes.number,
  onDelete: PropTypes.func,
  onCopy: PropTypes.func,
};

export default Bracket;
